export const SET_USERNAME = (state, value) => {
  state.username = value
}

export const SET_ROLE = (state, value) => {
  state.role = value
}

export const SET_EMAIL = (state, value) => {
  state.email = value
}

export const SET_ACTIVE = (state, value) => {
  state.active = value
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}
